const config = {
  proxy: process.env.PROXY || window.env.PROXY,
  apiVersion: process.env.API_VERSION || window.env.API_VERSION,
  platform_url: process.env.PLATFORM_URL || window.env.PLATFORM_URL,
};

export default {
  ...config,
};
